import e from "../../../utilities/tw.js";
const r = {
  base: e`pointer-events-none flex h-[27px] w-fit cursor-default items-center rounded-2xl px-3`,
  colors: {
    primary: e`bg-primary text-secondary hover:bg-primary-hover disabled:bg-disabled-surface disabled:text-disabled`,
    secondary: e`border border-primary bg-secondary text-primary hover:bg-secondary-hover disabled:bg-disabled-surface disabled:text-disabled`,
    tertiary: e`bg-accent text-primary-active hover:bg-accent-hover disabled:bg-disabled-surface disabled:text-disabled`,
    supplementary: e`bg-warning text-secondary hover:bg-warning-hover disabled:bg-disabled-surface disabled:text-disabled`,
    success: e`bg-success text-secondary hover:bg-success-hover disabled:bg-disabled-surface disabled:text-disabled`,
    error: e`bg-error text-secondary hover:bg-error-hover disabled:bg-disabled-surface disabled:text-disabled`,
    info: e`bg-info text-secondary hover:bg-info-hover disabled:bg-disabled-surface disabled:text-disabled`,
    disabled: e`bg-disabled-surface text-disabled `
  }
};
export {
  r as chipStyles
};
